/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `truck` - Camion / cap tractor
 * * `trailer` - Remorcă / semiremorcă
 */
export enum CMRVehicleCategoryEnum {
  TRUCK = 'truck',
  TRAILER = 'trailer',
}
